import React from "react";
import { classNames } from "@/lib/classNames";
import { useIsDesignSystem2 } from "@gettactic/hooks";

export interface ResponsiveLabelProps
  extends React.HTMLProps<HTMLLabelElement> {
  text: string;
  classes?: string;
  filled: boolean;
}

export const ResponsiveLabel = (props: ResponsiveLabelProps) => {
  const { className, text, classes, children, filled, ...rest } = props;
  const isV2 = useIsDesignSystem2();
  return (
    <div
      className={classNames(className, !isV2 && "responsive-label relative")}
    >
      {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
      <label
        className={classNames(
          classes,
          filled && "filled",
          "pointer-events-none static block rounded-lg bg-white p-0 font-bold text-gray-700 text-trueGray-500 transition-transform duration-200 ease-out"
        )}
        {...rest}
      >
        {text}
      </label>
      {children}
    </div>
  );
};

export default ResponsiveLabel;
